import React from 'react';
import styles from './ModuleBlocImagesCroise.scss';
import * as tools from '../Tools';

export class ModuleBlocImagesCroise extends React.Component {
	blocImage(data) {
		return (
			<div className="col-md-6 no-gutters">
				<div style={{ position: 'relative' }}>
					{data.titreImg && (
						<div
							className="text-center text-white pt-2 ft-parisienne"
							style={{
								backgroundColor: (data.titleBackgroundColor || '#f2c718'),
								width: '200px',
								height: '45px',
								position: 'absolute',
								marginLeft: '35%',
								fontSize: '140%'
							}}
						>
							{data.titreImg}
						</div>
					)}
					<img
						src={`${tools.lienPhotos}/${data.imgSrc}`}
						className="img-fluid"
						style={{}}
					/>
				</div>
			</div>
		);
	}

	mobile = data => {
		return (
			<React.Fragment>
				<img
					src={`${tools.lienPhotos}/${data.imgSrc}`}
					className="img-fluid"
					style={{ width: '100%' }}
				/>
				<div className="p-4 pt-5">
					<h1 className="contenu-h1">{data.titre}</h1>
					<h2 className="contenu-h2" style={{ padding: '10px 0px 0px 0px' }}>{data.sousTitre}</h2>
					<div className="pt-5">{data.contenu}</div>
				</div>
			</React.Fragment>
		);
	};

	grandEcranBlocTexteGauche = data => {
		return (
			<React.Fragment>
				{this.contenu(data)}
				{this.blocImage(data)}
			</React.Fragment>
		);
	};

	grandEcranBlocTexteDroit = data => {
		return (
			<React.Fragment>
				{this.blocImage(data)}
				{this.contenu(data)}
			</React.Fragment>
		);
	};

	contenu = data => {
		return (
			<React.Fragment>
				<div className="col-lg-1 no-gutters"></div>
				<div className="col-lg-4 col-md-5 no-gutters">
					<div className={"p-2 " + styles.croiseContenu} style={{ }}>
						{tools.titreSousTitre(data.titre, data.titreSousTitre)}
						{data.contenu}
					</div>
				</div>
				<div className="col-lg-1 no-gutters"></div>
			</React.Fragment>
		);
	};

	render() {
		const data = this.props.data;

		return (
			<div className="">
				<div className="d-none d-xl-block no-gutters">
					<div className="row no-gutters">
						{this.props.data.textPosition === 'droite' &&
							this.grandEcranBlocTexteDroit(data)}
						{this.props.data.textPosition === 'gauche' &&
							this.grandEcranBlocTexteGauche(data)}
					</div>
				</div>
				<div className="d-block d-xl-none">{this.mobile(data)}</div>
			</div>
		);
	}
}
